import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'da', label: 'Dansk' },
  { code: 'de', label: 'Deutsch' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current =
    languages.find((l) => l.code === (i18n.language?.split('-')[0] ?? 'en'))?.label ??
    'English';

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const select = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/70 bg-background-50/70 px-3 py-1.5 text-sm font-medium text-foreground-800 transition hover:bg-background-100"
      >
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-global-line text-base text-foreground-700"></i>
        </span>
        <span className="font-label">{current}</span>
        <span className="flex h-4 w-4 items-center justify-center">
          <i
            className={`ri-arrow-down-s-line text-sm text-foreground-600 transition-transform ${open ? 'rotate-180' : ''}`}
          ></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => select(l.code)}
              className={`flex w-full items-center justify-between whitespace-nowrap px-4 py-2 text-left text-sm transition hover:bg-background-100 ${
                l.code === (i18n.language?.split('-')[0] ?? 'en')
                  ? 'font-semibold text-primary-700'
                  : 'text-foreground-700'
              }`}
            >
              <span className="font-label">{l.label}</span>
              {l.code === (i18n.language?.split('-')[0] ?? 'en') && (
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-check-line text-sm text-primary-600"></i>
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}